
export class Header{
    constructor(data){
        this.id = data.id;
        this.title = data.title;
        this.title_eng = data.title_eng;
        this.src = data.src;
        this.link = data.link;
    } 
}